import * as React from 'react'
import styled from 'styled-components'
import Modal, { IFModalProps } from 'app.components/Modal/Modal'
import MobileHeader from '../../MobileHeader'
import FollowingListMobile from '../../lists/FollowingListMobile'
import RecommendChannelListMobile from '../../lists/RecommendChannelListMobile'

type IFFollowingsModalMobileProps = IFModalProps

const FollowingsModalMobile: React.FC<IFFollowingsModalMobileProps> = ({
  onClose,
  ...props
}) => {
  return (
    <Modal onClose={onClose} {...props} animation="left">
      <StyledWrapper>
        <MobileHeader onClose={onClose} title="팔로우한 채널" />
        <div className="hr" />
        <div className="channel-list">
          <FollowingListMobile />
          <RecommendChannelListMobile />
        </div>
      </StyledWrapper>
    </Modal>
  )
}
export default FollowingsModalMobile

const StyledWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: white;
  display: flex;
  flex-direction: column;

  .hr {
    width: 100%;
    height: 1px;
    background-color: #eee;
  }
  .channel-list {
    overflow: scroll;
  }
`
